export * from './getPositionTime';
export * from './getProgressPercent';
export * from './makeEbookLocatorCompatible';
//# sourceMappingURL=index.js.map